import { gql } from 'graphql-request'

export const DELETE_PROMOTION = gql`
  mutation RemovePromotion($id: Float!) {
    removePromotion(id: $id) {
      id
    }
  }
`
